// extracted by mini-css-extract-plugin
export var blogPostImageContainer = "image-module--blogPostImageContainer--jU-TL";
export var blogPostImage = "image-module--blogPostImage--PoSjM";
export var description = "image-module--description--6lZUu";
export var attribution = "image-module--attribution--8s9cT";
export var imageLinkStyle = "image-module--imageLinkStyle--Gdz0U";
export var imageAttributionContainer = "image-module--imageAttributionContainer--xgJXP";